<template>
  <v-dialog
    v-model="display"
    width="800"
  > 
    <v-container class="review-config-changes">
      <v-row>
        <v-col>
          <h3>Review Config Changes</h3>
        </v-col>
      </v-row>
      <br/>
      <!-- <v-row>
        
      </v-row> -->
      <v-data-table 
          :headers="headers"
          :items="changeList"
          :sort-desc="true"
        >
        </v-data-table>   
      <v-row>
        <v-spacer/>
        <v-col cols="2">
          <v-btn text color="red" @click="close">
            Close
          </v-btn>
        </v-col>
      </v-row>
       
    </v-container>
    
  </v-dialog>
</template>

<script>

import map from '../JSON/map.json'

import { Logger } from "aws-amplify"
const logger = new Logger("Review Job Config Change")

var xml2js = require('xml2js');

var get = require('lodash.get');


export default {
  name: 'ReviewJobConfigChange',
  props: {
    config: {
      type: String,
      required: true
    },
    display: {
      type: Boolean,
      required: true
    }
  }, 
  data() {
    return {
      decodedConfig: null,
      parsedConfigPaths: [],
      configMap: map,
      changeList: [],
      headers: [
        { text: "Setting", value: "label" },
        { text: "Updated Value", value: "value" },
      ]
    }
  },
  computed: {
    flatPathList() {
      return this.parsedConfigPaths.flat();
    }
  }, 
  watch: {
    decodedConfig: {
      handler() {
        this.compileChangeList();
      },
      deep: true
    }
  },
  mounted() {
    this.decodeConfig();
  },  
  methods: {
    compileChangeList() {
      this.changeList = [];

      this.flatPathList.forEach((item) => {
        if (this.findConfigValue(item, this.configMap) && this.findConfigValue(item, this.decodedConfig.device_config)) {
          const labelValueObj = {
            label: this.findConfigLabel(item, this.configMap),
            value: this.findConfigValue(item, this.decodedConfig.device_config)
          } 

          this.changeList.push(labelValueObj);
        }
      })
    },

    findConfigLabel(key, obj) {
      const propExists = Object.hasOwn(obj, key);
    
      return propExists ? obj[key] : null;
    },  

    findConfigValue (key, obj) {
      const val = get(obj, key);

      return val;
    },  

    decodeConfig() {
      this.loading = true;

      let decodedBase64 = atob(this.config);
      let xmlParser = new DOMParser();
      let xml = xmlParser.parseFromString(decodedBase64, "text/xml");
      let serialiser = new XMLSerializer();
      let xmlString = serialiser.serializeToString(xml);

      // convert our xml data to JSON
      xml2js.parseString(xmlString, (err, result) => {
        if (result) {
          logger.info('loadExternalConfig : ', result)
          this.decodedConfig = result;


          // const data = this.toDotList(this.decodedConfig)
          this.parseConfig(this.decodedConfig.device_config)
        }
      });
    },

    parseConfig(config) {
      Object.entries(config).forEach(([key, value]) => {
        this.parsedConfigPaths.push(this.parseObjectPaths(key, value));
      });
    },

    parseObjectPaths(currPath, item, paths = []) {
      paths.push(currPath);
      
      if (Array.isArray(item)) {
        item.forEach((el, idx) => {
          let pathStr = `${currPath}.[${idx}]`.replace('.[', '[');

          this.parseObjectPaths(pathStr, el, paths)
        });
      } else if (typeof item == "object") {
        Object.entries(item).forEach(([key, value]) => {
          this.parseObjectPaths(`${currPath}.${key}`, value, paths);
        });
      }

      return paths;
    },

    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
  .review-config-changes {
    background: white;

    h3 {
      padding-left: 0.5em;
    }
  }
</style>